<div class="popup-container tlms-popup">
  <header>
    <div class="header" style="display:block">Late Confirmation</div>
    <button class="close" style="top:-3px" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <ng-container>
    <div style="padding: 16px 24px 16px 24px;">
      <div class="col-12" style="width: 100%;">
        <div class="upload">
          <div class="row">
            <div class="col-2">
              <label class="catlabel">Task:</label>
            </div>
            <div class="col-10">
              <span class="content"> {{ taskName }}</span>
            </div>
          </div>
          <div class="content-line">
            <label class="catlabel">Due:</label>
            <span class="content"> {{ due }} </span>
          </div>
          <div class="content-line">
            <label class="catlabel">Status:</label>
            <span class="content">
              <select class="status" [(ngModel)]="selectedStatus" (change)="statusChange()">
                <option *ngFor="let status of statusData" [value]="status.statusID">
                  {{status.description}}
                </option>
              </select>
            </span>
          </div>
          <div *ngIf="enableReason" class="content-line">
            <label class="catlabel">Reason:</label>
            <span class="content">
              <select class="reason" [(ngModel)]="selectedReason1" (change)="onReasonDrpDwn1Change()">
                <option *ngFor="let reason of reasonData1" [value]="reason.latereasonID">
                  {{reason.description}}
                </option>
              </select>
            </span>
            <span class="content" style="margin-left:2%">
              <select class="reason" [(ngModel)]="selectedReason2" (change)="onReasonDrpDwn2Change()">
                <option *ngFor="let reason of reasonData2" [value]="reason.latereasonID">
                  {{reason.description}}
                </option>
              </select>
            </span>
            <span class="content" style="margin-left:2%">
              <select class="reason" [(ngModel)]="selectedReason3" (change)="onReasonDrpDwn3Change()">
                <option *ngFor="let reason of reasonData3" [value]="reason.latereasonID">
                  {{reason.description}}
                </option>
              </select>
            </span>
          </div>
          <div *ngIf="enableOther" class="content-line">
            <label class="catlabel">Other:</label>
            <input type="text" id="other" name="other" required class="other" [(ngModel)]="otherData">
          </div>
        </div>
        <label *ngIf="enableError" class="errormsg"> {{errormsg}} </label>
      </div>
    </div>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
      <button (click)="onNoClick()" class="mCancel"> CANCEL
      </button>
      <button class="taskm-submit" style="display: inline" (click)="saveClick()">
        SAVE
      </button>
    </div>
  </ng-container>
</div>